import { Component } from 'react';

// Catches render crashes in the active page so one bad row or unexpected
// API shape shows a recoverable message instead of a black screen.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    // Navigating to another page clears the error
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--err)', marginBottom: 8 }}>
          Something went wrong on this page
        </div>
        <div style={{ fontSize: 12, color: 'var(--muted-2)', marginBottom: 16, fontFamily: 'monospace' }}>
          {String(this.state.error?.message || this.state.error)}
        </div>
        <button
          className="btn btn-secondary"
          onClick={() => this.setState({ error: null })}
        >
          Try again
        </button>
      </div>
    );
  }
}
